(function(){
  'use strict';
  if(window.DaLucaUniversalImageViewerV397) return;
  window.DaLucaUniversalImageViewerV397=true;

  const qs=(s,r=document)=>r.querySelector(s);
  const qsa=(s,r=document)=>Array.from(r.querySelectorAll(s));

  function activeSlides(gallery){
    let slides=qsa('.product-images__slide.is-active',gallery).filter(s=>qs('.product-single__media-image img',s));
    if(!slides.length){
      slides=qsa('.product-images__slide',gallery).filter(s=>{
        if(!qs('.product-single__media-image img',s)) return false;
        if(s.hidden || s.getAttribute('aria-hidden')==='true') return false;
        const st=getComputedStyle(s);
        return st.display!=='none' && st.visibility!=='hidden';
      });
    }
    return slides;
  }

  function sourceFromSlide(slide){
    const zoom=qs('.product-single__media-zoom[href]',slide);
    const img=qs('.product-single__media-image img',slide);
    let full=zoom && zoom.href ? zoom.href : (img ? (img.currentSrc||img.src||'') : '');
    if(full && /([?&])width=\\d+/i.test(full)) full=full.replace(/([?&])width=\\d+/i,'$1width=2400');
    else if(full) full+=(full.includes('?')?'&':'?')+'width=2400';
    return {
      full,
      thumb: img ? (img.currentSrc||img.src||full) : full,
      alt: img ? (img.alt||'Product image') : 'Product image',
      slide
    };
  }

  function collect(gallery){
    return activeSlides(gallery).map(sourceFromSlide).filter(x=>x.full);
  }

  function selectedIndex(gallery,items){
    const selected=qs('.product-images__slide.is-selected, .product-images__slide.is-active.is-selected',gallery);
    if(selected){
      const i=items.findIndex(x=>x.slide===selected);
      if(i>=0) return i;
    }
    const img=qs('.product-images__slide.is-selected img, .product-images__slide.is-active img',gallery);
    if(img){
      const slide=img.closest('.product-images__slide');
      const i=items.findIndex(x=>x.slide===slide);
      if(i>=0) return i;
    }
    return 0;
  }

  function create(){
    let box=qs('.daluca-universal-image-viewer');
    if(box) return box;
    box=document.createElement('div');
    box.className='daluca-universal-image-viewer';
    box.setAttribute('aria-hidden','true');
    window.DaLucaI18n.setHtml(box, `
      <div class=\"daluca-universal-image-viewer__backdrop\" data-dluv-close></div>
      <div class=\"daluca-universal-image-viewer__panel\" role=\"dialog\" aria-modal=\"true\" aria-label=\"Product image viewer\">
        <div class=\"daluca-universal-image-viewer__stage\">
          <img class=\"daluca-universal-image-viewer__image\" alt=\"\">
          <button type=\"button\" class=\"daluca-universal-image-viewer__close\" data-dluv-close aria-label=\"Close image viewer\">×</button>
          <button type=\"button\" class=\"daluca-universal-image-viewer__arrow daluca-universal-image-viewer__arrow--prev\" data-dluv-prev aria-label=\"Previous product image\"></button>
          <button type=\"button\" class=\"daluca-universal-image-viewer__arrow daluca-universal-image-viewer__arrow--next\" data-dluv-next aria-label=\"Next product image\"></button>
          <div class=\"daluca-universal-image-viewer__counter\" aria-live=\"polite\"></div>
          <div class=\"daluca-universal-image-viewer__toolbar\" aria-label=\"Image zoom controls\">
            <button type=\"button\" data-dluv-zoom-out aria-label=\"Zoom out\">−</button>
            <button type=\"button\" data-dluv-reset aria-label=\"Reset zoom\">100%</button>
            <button type=\"button\" data-dluv-zoom-in aria-label=\"Zoom in\">+</button>
          </div>
        </div>
        <div class=\"daluca-universal-image-viewer__thumbs\" aria-label=\"Product image thumbnails\"></div>
      </div>`);
    document.body.appendChild(box);
    return box;
  }

  const state={items:[],index:0,scale:1,x:0,y:0,dragging:false,gestureActive:false,startX:0,startY:0,originX:0,originY:0,swipeX:0,opener:null};

  function setup(){
    const box=create();
    if(box.dataset.bound==='1') return box;
    box.dataset.bound='1';
    const stage=qs('.daluca-universal-image-viewer__stage',box);
    const image=qs('.daluca-universal-image-viewer__image',box);
    const thumbs=qs('.daluca-universal-image-viewer__thumbs',box);
    const reset=qs('[data-dluv-reset]',box);
    const counter=qs('.daluca-universal-image-viewer__counter',box);
    const pointers=new Map();
    let pinch=null, hadPinch=false;
    stage.style.touchAction='none';

    const clamp=(v,min,max)=>Math.max(min,Math.min(max,v));
    function renderTransform(){
      state.scale=clamp(state.scale,1,4);
      if(state.scale===1){state.x=0;state.y=0;}
      image.style.transform=`translate3d(${state.x}px,${state.y}px,0) scale(${state.scale})`;
      image.style.cursor=state.scale>1?(state.dragging?'grabbing':'grab'):'zoom-in';
      window.DaLucaI18n.setText(reset, Math.round(state.scale*100)+'%');
    }
    function resetZoom(){pointers.clear();pinch=null;hadPinch=false;state.gestureActive=false;state.scale=1;state.x=0;state.y=0;state.dragging=false;renderTransform();}
    function preload(i){
      if(!state.items.length) return;
      const idx=(i+state.items.length)%state.items.length;
      const pre=new Image(); pre.src=state.items[idx].full;
    }
    function renderThumbs(){
      window.DaLucaI18n.setHtml(thumbs, '');
      state.items.forEach((item,i)=>{
        const b=document.createElement('button');
        b.type='button'; b.className='daluca-universal-image-viewer__thumb'+(i===state.index?' is-active':'');
        b.setAttribute('aria-label','View product image '+(i+1));
        window.DaLucaI18n.setHtml(b, '<img alt=\"\">');
        const im=qs('img',b); im.src=item.thumb; im.alt=item.alt;
        b.addEventListener('click',()=>show(i));
        thumbs.appendChild(b);
      });
    }
    function syncThumb(){
      qsa('.daluca-universal-image-viewer__thumb',thumbs).forEach((b,i)=>b.classList.toggle('is-active',i===state.index));
      const active=qs('.daluca-universal-image-viewer__thumb.is-active',thumbs);
      active && active.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});
    }
    function show(i){
      if(!state.items.length) return;
      state.index=(i+state.items.length)%state.items.length;
      const item=state.items[state.index];
      image.alt=item.alt;
      image.src=item.full;
      resetZoom();
      window.DaLucaI18n.setText(counter, (state.index+1)+' / '+state.items.length);
      box.dataset.count=String(state.items.length);
      syncThumb();
      preload(state.index+1); preload(state.index-1);
    }
    function next(){show(state.index+1);}
    function prev(){show(state.index-1);}
    function close(){
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden','true');
      document.documentElement.classList.remove('daluca-universal-viewer-open');
      document.body.classList.remove('daluca-universal-viewer-open');
      resetZoom();
      const op=state.opener; state.opener=null;
      if(op && typeof op.focus==='function') setTimeout(()=>op.focus({preventScroll:true}),0);
    }
    function open(gallery,index,opener){
      state.items=collect(gallery);
      if(!state.items.length) return;
      state.index=Math.max(0,Math.min(index,state.items.length-1));
      state.opener=opener||null;
      renderThumbs(); show(state.index);
      box.classList.add('is-open');
      box.setAttribute('aria-hidden','false');
      document.documentElement.classList.add('daluca-universal-viewer-open');
      document.body.classList.add('daluca-universal-viewer-open');
      setTimeout(()=>qs('button[data-dluv-close]',box)?.focus({preventScroll:true}),0);
    }

    box._dluvOpen=open;
    qsa('[data-dluv-close]',box).forEach(el=>el.addEventListener('click',close));
    qs('[data-dluv-next]',box).addEventListener('click',next);
    qs('[data-dluv-prev]',box).addEventListener('click',prev);
    qs('[data-dluv-zoom-in]',box).addEventListener('click',()=>{state.scale=clamp(state.scale+.25,1,4);renderTransform();});
    qs('[data-dluv-zoom-out]',box).addEventListener('click',()=>{state.scale=clamp(state.scale-.25,1,4);renderTransform();});
    reset.addEventListener('click',resetZoom);

    stage.addEventListener('wheel',e=>{
      if(!box.classList.contains('is-open')) return;
      e.preventDefault();
      state.scale=clamp(state.scale+(e.deltaY<0?.2:-.2),1,4); renderTransform();
    },{passive:false});
    stage.addEventListener('dblclick',e=>{if(e.target.closest('button,a,input,select,textarea'))return;e.preventDefault();state.scale=state.scale===1?1.8:1;renderTransform();});
    stage.addEventListener('pointerdown',e=>{
      if(e.target.closest('button,a,input,select,textarea'))return;
      if(e.pointerType==='mouse' && e.button!==0)return;
      if(!pointers.size)hadPinch=false;
      pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
      stage.setPointerCapture?.(e.pointerId);
      state.gestureActive=true;
      if(pointers.size===2){
        const [a,b]=Array.from(pointers.values());
        const rect=stage.getBoundingClientRect();
        pinch={distance:Math.max(1,Math.hypot(b.x-a.x,b.y-a.y)),scale:state.scale,x:state.x,y:state.y,midX:(a.x+b.x)/2,midY:(a.y+b.y)/2,centerX:rect.left+rect.width/2,centerY:rect.top+rect.height/2};
        hadPinch=true;state.dragging=false;
        return;
      }
      if(pointers.size>2)return;
      state.swipeX=e.clientX;
      if(state.scale<=1) return;
      state.dragging=true; state.startX=e.clientX; state.startY=e.clientY; state.originX=state.x; state.originY=state.y;
      renderTransform();
    });
    stage.addEventListener('pointermove',e=>{
      if(!pointers.has(e.pointerId))return;
      pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
      if(pinch && pointers.size>=2){
        const [a,b]=Array.from(pointers.values());
        state.scale=clamp(pinch.scale*Math.hypot(b.x-a.x,b.y-a.y)/pinch.distance,1,4);
        const ratio=state.scale/pinch.scale;
        state.x=(a.x+b.x)/2-pinch.centerX-(pinch.midX-pinch.centerX-pinch.x)*ratio;
        state.y=(a.y+b.y)/2-pinch.centerY-(pinch.midY-pinch.centerY-pinch.y)*ratio;
        renderTransform();return;
      }
      if(!state.dragging || state.scale<=1) return;
      state.x=state.originX+(e.clientX-state.startX); state.y=state.originY+(e.clientY-state.startY); renderTransform();
    });
    stage.addEventListener('pointerup',e=>{
      if(!pointers.has(e.pointerId))return;
      pointers.delete(e.pointerId);
      if(pointers.size){
        pinch=null;
        const remaining=pointers.values().next().value;
        state.startX=remaining.x;state.startY=remaining.y;state.originX=state.x;state.originY=state.y;
        state.dragging=state.scale>1;renderTransform();return;
      }
      pinch=null;
      state.gestureActive=false;
      if(state.scale<=1 && !hadPinch){
        const dx=e.clientX-state.swipeX;
        if(Math.abs(dx)>60) (dx<0?next:prev)();
      }
      state.dragging=false; renderTransform();
    });
    stage.addEventListener('pointercancel',()=>{pointers.clear();pinch=null;hadPinch=false;state.gestureActive=false;state.dragging=false;renderTransform();});

    document.addEventListener('keydown',e=>{
      if(!box.classList.contains('is-open')) return;
      if(e.key==='Tab'){
        const buttons=qsa('button:not([disabled])',box).filter(el=>el.getClientRects().length);
        const first=buttons[0],last=buttons[buttons.length-1];
        if(first&&(!box.contains(document.activeElement)||(e.shiftKey&&document.activeElement===first))){e.preventDefault();(e.shiftKey?last:first).focus();}
        else if(last&&!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
      }
      else if(e.key==='Escape'){e.preventDefault();close();}
      else if(e.key==='ArrowRight'){e.preventDefault();next();}
      else if(e.key==='ArrowLeft'){e.preventDefault();prev();}
      else if(e.key==='+' || e.key==='='){e.preventDefault();state.scale=clamp(state.scale+.25,1,4);renderTransform();}
      else if(e.key==='-'){e.preventDefault();state.scale=clamp(state.scale-.25,1,4);renderTransform();}
      else if(e.key==='0'){e.preventDefault();resetZoom();}
    });
    return box;
  }

  function galleryFor(target){return target && target.closest ? target.closest('.product-gallery') : null;}

  // Document capture fires before older gallery-level lightbox handlers.
  document.addEventListener('click',function(e){
    const t=e.target; if(!t || !t.closest) return;
    const zoom=t.closest('.product-single__media-zoom, [data-daluca-zoom], .product-gallery__zoom, .product-image-zoom, button[aria-label*=\"zoom\" i], a[aria-label*=\"zoom\" i]');
    const hero=t.closest('.product-gallery .product-images__slide.is-selected .product-single__media-image img, .product-gallery .product-images__slide.is-active .product-single__media-image img');
    const trigger=zoom||hero; if(!trigger) return;
    const gallery=galleryFor(trigger); if(!gallery) return;
    const items=collect(gallery); if(!items.length) return;
    let index=selectedIndex(gallery,items);
    const slide=trigger.closest('.product-images__slide');
    if(slide){const i=items.findIndex(x=>x.slide===slide); if(i>=0) index=i;}
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    const box=setup(); box._dluvOpen(gallery,index,trigger);
  },true);
})();

